import { render, staticRenderFns } from "./ModelsConfig.vue?vue&type=template&id=3dad2379"
import script from "./ModelsConfig.vue?vue&type=script&lang=js"
export * from "./ModelsConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelsConfig.vue?vue&type=style&index=0&id=3dad2379&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports